import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const EndPointDiamondIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG {...props} viewBox="0 0 16 8" fill="none">
      <path d="M0.571411 4.00366H9.71427" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.5714 1.14648L9.71423 4.00363L12.5714 6.86077L15.4285 4.00363L12.5714 1.14648Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSVG>
  )
}
